import {
    App,
    Login,
    Public,
    Dashboard, Analysis,
    Projects, ProjectCreate, ProjectEdit, ProjectView, ProjectDelete, ProjectsList,
    Goals, GoalsList, GoalCreate, GoalEdit, GoalView, GoalDelete,
    Sprints, SprintsList, SprintCreate, SprintEdit, SprintView, SprintDelete, SprintMergeRequests,
    Quotes, QuotesList, QuoteCreate, QuoteEdit, QuoteView, QuoteDelete,
    PublicProjectView, PublicProjectReportView, PublicChangeView, PublicQuoteView,
    Users, UserCreate, UserEdit, UsersList, UserDelete, UserTracks, UserActivity,
    Settings, SettingEdit,
    DocumentationsList,
    TriageView,
    ChangesOverviewView,
    RtImportView,
    RequesterView,
    ClientView
} from './containers';

const routes = [
    {
        path: "public",
        element: <Public />,
        children: [
            {
                path: "projects",
                element: <Projects />,
                children: [
                    { path: ":id/changelog", element: <PublicProjectView /> },
                    { path: ":id/changelog/from/:from", element: <PublicProjectView /> },
                    { path: ":id/changelog/from/:from/merge/:merge", element: <PublicProjectView /> },
                    { path: ":id/diff/from/:from/to/:to", element: <PublicProjectView /> },
                    { path: ":id/diff/from/:from/to/:to/file/:file", element: <PublicProjectView /> },
                ]
            },
        {
            path: "support/project/:projectId/source/:source",
            element: <PublicProjectReportView />,
        },
        {
            path: "change/:id",
            element: <PublicChangeView />,
        },
        {
            path: "quotes/:token",
            element: <PublicQuoteView />,
        },
        ]
    },
    {
        path: "login",
        element: <Login />,
    },
    {
        path: "/",
        element: <App />,
        children: [
            { path: "", element: <Dashboard /> },
            { path: "projects", element: <Projects />, children: [
                { path: "", element: <ProjectsList /> },
                { path: "new", element: <ProjectCreate /> },
                { path: ":id", element: <ProjectView /> },
                { path: ":id/tab/:tab", element: <ProjectView /> },
                { path: ":id/release/:releaseId", element: <ProjectView /> },
                { path: ":id/change/:changeId", element: <ProjectView /> },
                { path: "edit/:id/tab/:tab", element: <ProjectEdit /> },
                { path: "edit/:id", element: <ProjectEdit /> },
                { path: "delete/:id", element: <ProjectDelete /> },
            ]},
            { path: "goals", element: <Goals />, children: [
                { path: "", element: <GoalsList /> },
                { path: "new", element: <GoalCreate /> },
                { path: ":id", element: <GoalView /> },
                { path: "edit/:id", element: <GoalEdit /> },
                { path: "delete/:id", element: <GoalDelete /> },
            ]},
            { path: "sprints", element: <Sprints />, children: [
                { path: "", element: <SprintsList /> },
                { path: "new", element: <SprintCreate /> },
                { path: ":id", element: <SprintView /> },
                { path: "edit/:id", element: <SprintEdit /> },
                { path: "delete/:id", element: <SprintDelete /> },
                { path: "mergerequests", element: <SprintMergeRequests /> },
            ]},
            { path: "quotes", element: <Quotes />, children: [
                { path: "", element: <QuotesList /> },
                { path: "new", element: <QuoteCreate /> },
                { path: ":id", element: <QuoteView /> },
                { path: "edit/:id", element: <QuoteEdit /> },
                { path: "delete/:id", element: <QuoteDelete /> },
            ]},
            { path: "users", element: <Users />, children: [
                { path: "", element: <UsersList /> },
                { path: "new", element: <UserCreate /> },
                { path: "edit/:id", element: <UserEdit /> },
                { path: "delete/:id", element: <UserDelete /> },
                { path: "tracks", element: <UserTracks /> },
                { path: "activity", element: <UserActivity /> },
            ]},
            { path: "settings", element: <Settings />, children: [
                { path: "edit/:id", element: <SettingEdit /> }
            ]},
            { path: "documentations", element: <DocumentationsList />, children: [
                { path: "", element: <DocumentationsList /> }
            ]},
            { path: "analysis", element: <Analysis />, children: [
                { path: "", element: <Analysis /> }
            ]},
            { path: "triage", element: <TriageView /> },
            { path: "rt-import", element: <RtImportView /> },
            { path: "changes", element: <ChangesOverviewView /> },
            { path: "requesters/:email", element: <RequesterView /> },
            { path: "clients", element: <ClientView /> },
            { path: "clients/:id", element: <ClientView /> },
        ]
    }
];

export default routes;
